module.exports = __webpack_public_path__ + "static/media/TVframe.936d2095.jpg";